export default __webpack_public_path__ + "static/media/error.2b90eb9b.png";